<!--
 * @Author: zyf
 * @Date: 2025-06-16 10:14:46
 * @LastEditors: zyf
 * @LastEditTime: 2025-06-19 18:02:18
 * @Descripttion: 
-->
<template>
  <div class="message-card-container">
    <div class="message-card">
      <p class="title">{{dataInfo.title}}</p>
      <div class="sub-title">
        <span>{{dataInfo.archi_name ? dataInfo.archi_name : '-'}}</span>
        <span>·</span>
        <span>{{dataInfo?.user_name ? dataInfo?.user_name : '-'}}</span>
        <span>{{getTime(dataInfo.created_at)}}</span>
        <span>发布</span>
      </div>
      <!-- 执行进度 -->
      <ul v-if="[2,3].includes(+dataInfo.msg_type) &&  extra && Object.keys(extra).length" class="file-list">
        <li class="file-item-box" :class="{'success-status': [0,1,2].includes(+dataInfo?.progress_status),'fail-status': +dataInfo?.progress_status === 3,'download': +dataInfo?.progress_status === 2}">
          <div class="left-content">
            <div class="icon">
              <img v-if="[0,1,2].includes(+dataInfo?.progress_status)" :src="+dataInfo.msg_type === 2 ? 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/a07f2bae561e6cb271d5ac5617982df8.png' : 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/b975e982b6251d09f5da11eaa384c53e.png'" alt="">
              <i v-else class="iconfont iconsousuoqingchu error-icon"></i>
            </div>
            <span class="name">{{getTitle}}</span>
          </div>
          <div class="right-content"  :class="{'has-download': +dataInfo.msg_type === 2}">
            <!-- <template v-if="+dataInfo?.msg_type === 3 && +dataInfo?.progress_status === 2">
              <span class="text">下载次数：{{dataInfo.count}}</span>
              <span class="text">{{dataInfo.file_size}}</span>
            </template> -->
            <span class="text">{{getStatus(dataInfo)}}</span>
            <span class="btn" @click="onDownload">下载</span>
          </div>
          <el-progress :key="'progress'" v-if="dataInfo?.progress !== 100 && +dataInfo?.progress_status === 1" class="custom-progress" color="#387FFC" :duration="3" :show-text="false" :format="(percent) => (`${percent}%`)" :percentage="dataInfo?.progress" :stroke-width="2" />
        </li>
      </ul>
      <!-- 评论 -->
      <div v-if="+dataInfo.msg_type === 6" class="form-box">
        <PageParser
          style="width: 100%; height: 100%"
          :key="page_uuid"
          :page_uuid="page_uuid"
          @initEnd="onInitEnd"
        ></PageParser>
      </div>
      <!-- <Editor
      :init="init"
      v-model="dataInfo.content"
      class="inner-editor"
      disabled /> -->
      <div v-if="+dataInfo.msg_type === 1" class="form-box editor-box" v-html="dataInfo?.content || '-'">
      </div>
    </div>
    <div v-if="showReissue || showJump" class="oprate-box">
      <el-button v-if="showReissue" type="neutral" status="secondary" @click="onReissue">重新发起</el-button>
      <el-button v-if="showJump" type="primary" status="secondary" @click="onJump">跳转至功能页面</el-button>
    </div>
  </div>
</template>
<script>
import {Button,Progress} from "element-ui";
import PageParser from '@/components/parser/Index';

export default {
  components: {
    "el-progress": Progress,
    "el-button": Button,
    PageParser,
  },
  props: {
    noticeInfo:{
      type: Object,
      default: ()=>{
        return {};
      }
    },
    showReissue:{
      type: Boolean,
      default: false
    },
    showJump:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dataInfo: {},
      init:{
        language: 'zh_CN',
        menubar: false, // 禁用菜单栏
        toolbar: '',
        height: '100%',
        branding: false,
        statusbar: false,
        inline: true //开启内联模式
      },
      page_uuid: 'pageu7hybkrhu6',
      pageAbility: null,
    };
  },
  computed: {
    extra() {
      return this.dataInfo?.extra || {};
    },
    getTitle() {
      if(+this.dataInfo.msg_type === 3){
        return this.dataInfo?.title || '-';
      }
      return this.extra?.zip_name ? `${this.extra?.zip_name}.zip` : '-';
    },
  },
  watch: {
    noticeInfo: {
      handler(val) {
        this.dataInfo = val;
      }
    },
  },
  methods:{
    getStatus(data){
      switch (+data?.progress_status) {
        case 0:
          return '待开始';
        case 1:
          return '执行中…';
        case 3:
          return '执行失败';
        default:
          return '执行完成';
      }
    },
    onInitEnd(ability) {
      this.pageAbility = ability;
    },
    getTime(time){
      if(time){
        const currentDate = new Date();
        const date = new Date(time);
        const currentYear = currentDate.getFullYear();
        const year = date.getFullYear();
        const currentDateString = currentDate.toISOString();
        if(time.slice(0,10)===currentDateString.slice(0,10)){
          return time.slice(time.length-9,time.length - 3);
        }else{
          if(currentYear === year){
            return time.slice(5,16);
          }
          return time.slice(0,10);
        }
      }else{
        return '-';
      }
    },

    onDownload(){
      this.$emit('download',this.dataInfo);
    },

    onReissue(){
      this.$emit('reissue',this.dataInfo);
    },

    onJump(){
      this.$emit('jump',this.dataInfo);
    },
  },
  mounted() {
    this.dataInfo = this.noticeInfo;
  },
  created() {},
}
</script>

<style lang="less" scoped>
.message-card-container{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .message-card{
    width: 100%;
    padding: 20px 24px;
    box-sizing: border-box;
    .title{
      width: 100%;
      color: var(--text-on-surface-primary, #181B22);
      font-family: "PingFang SC";
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0.5px;
    }
    .sub-title{
      width: 100%;
      padding-top: 8px;
      box-sizing: border-box;
      color: var(--text-on-surface-tertiary, #707786);
      font-family: "PingFang SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.4px;
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .file-list{
      width: 100%;
      padding-top: 24px;
      box-sizing: border-box;
      .file-item-box{
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        overflow: hidden;
        border-radius: 6px;
        padding: 0 16px 0 13px;
        box-sizing: border-box;
         cursor: pointer;
        background: linear-gradient(0deg, var(--overall-surface-alt-1, #F2F7FF) 0%, var(--overall-surface-alt-1, #F2F7FF) 100%), var(--overall-surface-variant, #F2F5FA);
        position: relative;
        :deep(.custom-progress){
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          .el-progress-bar{
            .el-progress-bar__outer{
              background: var(--overall-surface-variant, #F2F5FA);
            }
          } 
        }
        &.fail-status{
          background: var(--semantic-error-on-background-variant, #FFF4F4);
        }
        &.success-status{
          background: linear-gradient(0deg, var(--overall-surface-alt-1, #F2F7FF) 0%, var(--overall-surface-alt-1, #F2F7FF) 100%), var(--overall-surface-variant, #F2F5FA);
        }
        &.download{
          &:hover{
            .has-download{
              .text{
                display: none;
              }
              .btn{
                display: block;
              }
            }
          }
        }
        .left-content{
          flex: 1;
          overflow: hidden;
          display: flex;
          align-items: center;
          gap: 13px;
          .icon{
            width: 18px;
            height: 18px;
            flex-shrink: 0;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
            .error-icon{
              color: var(--semantic-error-on-background, #FC5558);
              font-size: 20px;
              display: block;
            }
          }
          .name{
            flex: 1;
            color: var(--text-on-surface-primary, #181B22);
            font-family: "PingFang SC";
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .right-content{
          flex-shrink: 0;
          display: flex;
          align-items: center;
          gap: 26px;
          .text,.btn{
            color: var(--text-on-surface-secondary, #424751);
            font-family: "PingFang SC";
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.4px;
          }
          .btn{
            color: #4794FF;
            cursor: pointer;
            display: none;
          }
        }
      }
    }
    .form-box{
      margin-top: 24px;
      width: 100%;
      height: auto;
      box-sizing: border-box;
      border-radius: 6px;
      border: 1px solid var(--border-on-surface-overlay, rgba(0, 0, 0, 0.06));
      background: var(--overall-surface-default, #FFF);
      &.editor-box{
        padding: 16px 20px;
        box-sizing: border-box;
        background: var(--overall-surface-variant, #f2f5fa);
        border: none;
      }
      .inner-editor{
        line-height: 1.5;
        overflow-y: auto; 
        overflow-x: hidden;
        flex: 1;
        :deep(img){
          width: 100%;
        }
      }
    }
  }
  .oprate-box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20px 24px;
    box-sizing: border-box;
    border-top: 1px solid var(--border-on-surface-weak, #F0F1F4);
  }
}
</style>